import { Tabs, Typography } from "antd";
import { ImageTypes } from "enums/imageTypes";
import { useIntl } from "react-intl";
import { ImageUploadForm } from "./ImageUploadForm";

type Props = {
  entity: any;
  readonly: boolean;
};

export const ImageUploader = ({ entity, readonly }: Props) => {
  const { formatMessage } = useIntl();
  if (!entity) {
    return null;
  }

  return (
    <Tabs
      style={{ marginLeft: "20px" }}
      centered
      type="card"
      tabBarStyle={{
        marginBottom: 0,
      }}
      items={[
        {
          key: "logo",
          label: (
            <Typography.Text className="text-upper">
              {formatMessage({ id: "entityEditPage.image.logo" })}
            </Typography.Text>
          ),
          children: <ImageUploadForm entity={entity} imageType={ImageTypes.Logo} readonly={readonly} />,
        },
        {
          key: "logo_alternate",
          label: (
            <Typography.Text className="text-upper">
              {formatMessage({ id: "entityEditPage.image.logoAlternate" })}
            </Typography.Text>
          ),
          children: <ImageUploadForm entity={entity} imageType="LOGO_ALTERNATE" readonly={readonly} />,
        },
        {
          key: "logo_background",
          label: (
            <Typography.Text className="text-upper">
              {formatMessage({ id: "entityEditPage.image.logoBackground" })}
            </Typography.Text>
          ),
          children: <ImageUploadForm entity={entity} imageType="LOGO_BACKGROUND" readonly={readonly} />,
        },
      ]}
    />
  );
};
